import { Component, OnInit, Inject } from '@angular/core';
import { CheckOutService } from '../../services/checkout.service';
import { NgProgress } from 'ngx-progressbar';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NgProgressService } from '../../services/ngProgress.service';

@Component({
  selector: 'app-terms-and-conditions',
  templateUrl: './terms-and-conditions.component.html',
  styleUrls: ['./terms-and-conditions.component.css']
})
export class TermsAndConditionsComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<TermsAndConditionsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private checkOutService: CheckOutService,
    private ngProgress: NgProgressService) { }

  ngOnInit() {
  }

  saveTermAndCondition(): void {
    this.ngProgress.start();
    this.checkOutService.UpdateTermsandVersion().subscribe((res: string) => {
      this.dialogRef.close(res);
      this.ngProgress.done();
    },
      (error: any) => {
        console.error(error);
        this.ngProgress.done();
      });
  }

  declineTermAndCondition(): void {
    this.dialogRef.close();
  }

}
